import { httpService } from "./httpService";

export const upgradeBoxService = {
  async planDetails() {
    try {
        const planDetails = await httpService.getRequest<any>("users/plan-details");
        const planDetailsData = planDetails.data;
        return planDetailsData;
    } catch (error) {
        console.error("Error fetching plan details:", error);
    }
  },
};

